module.exports = __webpack_public_path__ + "static/Cloud-1-f4eb3c87481cbcc39bef6368a43e9d1a.png";